/**
 * Title-case a proper name that is stored UPPERCASE in the DB (e.g. counterparty
 * names from `cp_vn`). Capitalises the first letter of each word, lower-cases the
 * rest. Unicode-aware so Vietnamese diacritics survive (CÔNG TY → Công Ty).
 *
 * Display-only: never mutate the stored value, only the rendered string.
 * Splits on whitespace but keeps original separators (spaces/tabs) intact.
 */
export function titleCaseName(value: unknown): string {
  if (value == null) return ''
  const s = String(value)
  if (!s) return ''
  return s.replace(/\S+/g, (word) => {
    const lower = word.toLocaleLowerCase()
    return lower.charAt(0).toLocaleUpperCase() + lower.slice(1)
  })
}
